import staticQueryData from "../../../../public/static/d/3503098761.json";
import React, { useEffect } from 'react';
import { StaticQuery } from 'gatsby';

function useScript(src) {
  useEffect(function () {
    var script = document.createElement('script');
    script.src = src;
    script.async = true;
    document.body.appendChild(script);
    return function () {
      document.body.removeChild(script);
    };
  }, [src]);
}

var QUERY = "3503098761";

function InnerCodeFund(_ref) {
  var property = _ref.property;
  useScript("https://codefund.io/properties/" + property + "/funder.js?template=image-centered&theme=light");
  return React.createElement("div", {
    id: "codefund"
  });
}

export function CodeFund() {
  return React.createElement(StaticQuery, {
    query: QUERY,
    render: function render(data) {
      return React.createElement(InnerCodeFund, {
        property: data.site.siteMetadata.codeFundProperty
      });
    },
    data: staticQueryData
  });
}